import { HealthInsurerForm } from '@/features/HealthInsurerForm/Component'
import { CancelFormConfirmModal } from '@/features/CancelFormConfirmModal/Component'
import { BasePage } from '../BasePage'
import { MainTitle } from '@/components/title/MainTitle'
import { useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react'

const style = {
  marginBottom: '1rem',
}
export const HealthInsurerFormPage = () => {
  const id = useParams().id
  const title = id ? '保険者更新' : '保険者登録'
  const navigate = useNavigate()
  const [isDirty, setIsDirty] = useState(false)
  const [showCancelConfirmModal, setShowCancelConfirmModal] = useState(false)

  const handleCancel = () => {
    if (isDirty) {
      setShowCancelConfirmModal(true)
      return
    }
    navigate('/health-insurers')
  }

  return (
    <>
      <BasePage title={title}>
        <MainTitle addStyle={style}>{title}</MainTitle>
        <HealthInsurerForm
          onCancel={handleCancel}
          onDirtyChange={setIsDirty}
        />
      </BasePage>
      {showCancelConfirmModal && (
        <CancelFormConfirmModal
          onConfirm={() => navigate('/health-insurers')}
          onCancel={() => setShowCancelConfirmModal(false)}
        />
      )}
    </>
  )
}
